import { render, staticRenderFns } from "./contractForm.vue?vue&type=template&id=864c35b6&scoped=true&"
import script from "./contractForm.vue?vue&type=script&lang=js&"
export * from "./contractForm.vue?vue&type=script&lang=js&"
import style0 from "./contractForm.vue?vue&type=style&index=0&id=864c35b6&scoped=true&lang=scss&"
import style1 from "./contractForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864c35b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('864c35b6')) {
      api.createRecord('864c35b6', component.options)
    } else {
      api.reload('864c35b6', component.options)
    }
    module.hot.accept("./contractForm.vue?vue&type=template&id=864c35b6&scoped=true&", function () {
      api.rerender('864c35b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/contractForm.vue"
export default component.exports